import { render, staticRenderFns } from "./QuotesInvoices.vue?vue&type=template&id=a204afc0&scoped=true&"
import script from "./QuotesInvoices.vue?vue&type=script&lang=ts&"
export * from "./QuotesInvoices.vue?vue&type=script&lang=ts&"
import style0 from "./QuotesInvoices.vue?vue&type=style&index=0&id=a204afc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a204afc0",
  null
  
)

export default component.exports